import React, { FC } from "react";
import { Form, Stack } from "react-bootstrap";
import { useDisableEnableVolunteerMutation } from "features/api/usersPermissionsManagement/usersPermissionsManagementApiSlice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { volunteerData } from "./volunteerTypes";

type Props = {
  volunteer: volunteerData;
};

const DisableUserAppCheckbox: FC<Props> = ({ volunteer }) => {
  const { t } = useTranslation();
  const [disableEnableVolunteer] = useDisableEnableVolunteerMutation();

  const HandleChangeCheckbox = async (userTz: string, isToDisable: boolean) => {
    await disableEnableVolunteer({ userTz, isToDisable }).unwrap();
  };

  return (
    <Stack direction="horizontal" className="disable-checkbox" gap={0}>
      <Form.Check
        type="switch"
        id="custom-switch"
        checked={volunteer?.userApp?.disable}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          !event.target.checked &&
            toast.info(t("attentionMissingDetails"), {
              autoClose: 2000,
            });
          HandleChangeCheckbox(volunteer?.userApp?.tz, event.target.checked);
        }}
        size={20}
      />
    </Stack>
  );
};

export default DisableUserAppCheckbox;
